import { render, staticRenderFns } from "./checkbox.component.vue?vue&type=template&id=7d8164a2&scoped=true&lang=pug"
import script from "./checkbox.component.vue?vue&type=script&lang=ts"
export * from "./checkbox.component.vue?vue&type=script&lang=ts"
import style0 from "./checkbox.component.vue?vue&type=style&index=0&id=7d8164a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8164a2",
  null
  
)

export default component.exports